import { InjectionToken } from "@angular/core";
import { IGroupQuickAccessMenuStateService } from "./i-group-quick-access-menu-state.service";

export const groupQuickAccessMenuStateServiceInjectionToken: InjectionToken<IGroupQuickAccessMenuStateService> = new InjectionToken<IGroupQuickAccessMenuStateService>("digital-signage.user-dashboard.dashboard-web.CloudQuickAccessMenuStateService");
